/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';

import { useForm, type ValidationMode } from 'react-hook-form';

import { InputThemeEnum as FormTheme } from './shared/utils/themes';
import type { InputThemeType as FormThemeType } from './shared/utils/themes';

import type { TFormField } from './shared/utils/types';

/**
 * Form Components
 */

import Builder from './Builder';

import Input from './Input';
import Checkbox from './Checkbox';

/**
 * Form Props
 */

import type { ICreateFormProps, TBuiltProps } from './_props';

/**
 * Form Namespace
 */

const useCreateForm = <TFormFields extends TFormField = TFormField>({
  builderOptions = {},
}: ICreateFormProps<TFormFields> = {}) => {
  const methods = useForm<TFormFields>({ mode: 'all', ...builderOptions });

  return useMemo(
    () => ({
      FormBuilder: (props: TBuiltProps<TFormFields>) => <Builder {...props} formMethods={methods} />,
      FormInput: Input<TFormFields>(),
      FormCheckbox: Checkbox<TFormFields>,
      formMethods: methods,
    }),
    [methods],
  );
};

/**
 * Exports
 */

export {
  // Theme
  FormTheme,
  FormThemeType,
  // Types
  type ValidationMode,
};

export default useCreateForm;
